import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-dcms-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.css'],
})
export class ButtonComponent implements OnInit {

  constructor(private router: Router, private route: ActivatedRoute) { }

  @Input() public settings: any;
  @Input() public data: any;

  public allPages: any[] = [];
  public api: any = '';


  public ngOnInit() {

    this.settings = this.settings || {};
    this.GetAllPages()
  }


  public GetAllPages() {
    if (this.data.dataChashingService && this.data.dataChashingService.pagesList) {
      this.allPages = this.data.dataChashingService.pagesList;
    } else {
      this.allPages = this.data.moduleService.siteSlugs;
      this.data.dataChashingService.pagesList = this.data.moduleService.siteSlugs;
    }
  }

  public getPageSlug(id) {
    const slug = this.allPages.find((s) => s.id === id);
    return slug ? '/' + slug.slug : this.allPages[0] ? this.allPages[0].slug : null;
  }

  public navigateToPage() {
    let link = this.getPageSlug(this.settings.pageId);
    this.router.navigate([link]);
    if (this.settings.divId) {
      setTimeout(() => {
        this.navigateToSection(this.settings.divId)
      }, 200);
    }
  }


  public navigateToSection(el) {
    const elmnt = document.getElementById(el);
    if (elmnt && elmnt != null) {
      elmnt.scrollIntoView();
    }
  }







  public navigateToCulture() {
    let link = ''
    if (this.route.data['value'].type == 1)
      link = this.getCultureLinkedPage(this.route.data['value'].id, this.settings.Culture);
    else
      link = this.getCultureLinkedBlog(this.route.data['value'].id, this.settings.Culture);

    if (link != '/' && this.data.moduleService.site.css) {
      this.setsiteCss(this.settings.Culture)
      this.data.moduleService.site.culture = this.settings.Culture;
      this.router.navigate([link]);
    }

  }


  public getCultureLinkedPage(id, culture) {
    const currentPage = this.data.dataChashingService.pages[id]
    if (currentPage.addtionalMetaTags && currentPage.addtionalMetaTags != null) {
      let temp = JSON.parse(currentPage.addtionalMetaTags)
      for (let i = 0; i < temp.length; i++) {
        const element = temp[i];
        if (element.property == culture) {
          return this.setNewRoute(this.settings.prefix || '', element.content)
        }
      }
    }
    return '/';
  }


  public getCultureLinkedBlog(id, culture) {
    const currentPage = this.data.dataChashingService.blogs[id]
    if (currentPage.addtionalMetaTags && currentPage.addtionalMetaTags != null) {
      let temp = JSON.parse(currentPage.addtionalMetaTags)
      for (let i = 0; i < temp.length; i++) {
        const element = temp[i];
        if (element.property == culture) {
          return this.setNewRoute(this.settings.prefix || '', element.content)
        }
      }
    }
    return '/';
  }


  public setNewRoute(prefix, newRoute) {
    this.router.config = [];
    this.data.moduleService.site.HostName = prefix.replace("/", '');
    this.data.routerService.getRoute();
    return '/' + prefix + newRoute
  }


  public setsiteCss(Culture) {
    let css = JSON.parse(this.data.moduleService.site.css);
    const head = document.getElementsByTagName('head')[0];
    if (css[Culture]) {
      const oldCss = document.getElementsByTagName('style');
      for (let index = 0; index < oldCss.length; index++) {
        const element = oldCss[index];
        if (element.id.indexOf(this.data.moduleService.site.culture + '-style') !== -1) {
          head.removeChild(element);
          index = index - 1;
        }
      }
      const culture_css = document.createElement('style');
      culture_css.type = 'text/css';
      culture_css.id = Culture + '-style';
      culture_css.appendChild(document.createTextNode(css[this.settings.Culture]));
      head.appendChild(culture_css);
    }
  }






}
